(function () {
  'use strict';

  var destinations = {
    '/pages/private-access': 'private_access',
    '/pages/find-your-world': 'find_your_world',
    '/pages/discovery-set': 'discovery_set'
  };

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function analyticsAllowed() {
    try {
      if (
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      ) {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (error) {}
    return true;
  }

  function getUtm() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || ''
    };
  }

  function publish(payload) {
    if (!analyticsAllowed()) return;

    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function'
      ) {
        Shopify.analytics.publish('icbm:cta_click', payload).catch(function () {});
      }
    } catch (error) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'icbm_cta_click',
        icbm_destination: payload.destination,
        icbm_destination_path: payload.destination_path,
        icbm_source_path: payload.source_path,
        icbm_link_text: payload.link_text,
        icbm_device_view: payload.device_view,
        utm_source: payload.utm_source,
        utm_medium: payload.utm_medium,
        utm_campaign: payload.utm_campaign,
        utm_content: payload.utm_content
      });
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;

    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    var destination = destinations[url.pathname];
    if (!destination) return;

    var utm = getUtm();

    publish({
      destination: destination,
      destination_path: url.pathname,
      source_path: window.location.pathname,
      source_title: document.title || '',
      link_text: cleanText(link.textContent),
      device_view: window.innerWidth <= 768 ? 'mobile' : 'desktop',
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_content: utm.utm_content
    });
  }, true);
})();